const SESSION_KEY = "resident-claim:requires-profile-completion";

export function setRequiresProfileCompletionPending(value: boolean): void {
  try {
    if (value) {
      sessionStorage.setItem(SESSION_KEY, "1");
    } else {
      sessionStorage.removeItem(SESSION_KEY);
    }
  } catch {
    // Private browsing / disabled storage
  }
}

export function peekRequiresProfileCompletionPending(): boolean {
  try {
    return sessionStorage.getItem(SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearRequiresProfileCompletionPending(): void {
  setRequiresProfileCompletionPending(false);
}
